import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="guide-list"
export default class extends Controller {
  static targets = ["searchInput"]

  connect() {
    // Initialize any needed functionality
  }

  submitForm(event) {
    event.preventDefault()
    const form = event.target.closest('form')
    if (form) {
      form.requestSubmit()
      // Close the drawer after submitting
      const drawer = document.getElementById('guide-filters-drawer')
      if (drawer) {
        drawer.checked = false
      }
    }
  }

  clearFilters(event) {
    event.preventDefault()
    const form = event.target.closest('form')
    if (form) {
      // Clear all form inputs
      const inputs = form.querySelectorAll('input[type="radio"], input[type="text"], input[type="search"]')
      inputs.forEach(input => {
        if (input.type === 'radio') {
          input.checked = input.value === ''
        } else {
          input.value = ''
        }
      })
      
      // Submit the cleared form
      form.requestSubmit()
      
      // Close the drawer
      const drawer = document.getElementById('guide-filters-drawer')
      if (drawer) {
        drawer.checked = false
      }
    }
  }
} 